var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 21.2324H19.893C20.996 21.2324 21.893 20.3354 21.893 19.2324V5.23242C21.893 4.12942 20.996 3.23242 19.893 3.23242H4C2.897 3.23242 2 4.12942 2 5.23242V19.2324C2 20.3354 2.897 21.2324 4 21.2324ZM4 19.2324V14.2324H8V19.2324H4ZM14 7.23242V12.2324H10V7.23242H14ZM8 7.23242V12.2324H4V7.23242H8ZM10 19.2324V14.2324H14V19.2324H10ZM16 19.2324V14.2324H19.894V19.2324H16ZM19.893 12.2324H16V7.23242H19.893V12.2324Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableicon);
export default __webpack_public_path__ + "static/media/tableicon.646d8e3df5205b62e3b38475f11d26b6.svg";
export { ForwardRef as ReactComponent };